import React, { useEffect, useState } from 'react';
import { useQuery, useMutation } from '@apollo/client';

import { Form, Field, Label } from 'app/src/components/Orders/PrintSetup';
import { Button } from 'app/src/elements/buttons';
import { StyledTextInput } from 'app/src/elements/inputs';
import { Picker } from 'app/src/elements/Picker';
import { Subtitle } from 'app/src/styles';

import { PRINTER_SETUPS, PRINT_ALIGNMENT_TEMPLATE } from './queries';

const PrintTemplate = ({ isMobile }) => {
  const [printerSetup, setPrinterSetup] = useState('');
  const [quantity, setQuantity] = useState('');
  const [formStatus, setFormStatus] = useState();

  const { data } = useQuery(PRINTER_SETUPS);
  const [printAlignmentTemplate] = useMutation(PRINT_ALIGNMENT_TEMPLATE, {
    onCompleted: () => {
      setQuantity('');
      setFormStatus(null);
    }
  });

  useEffect(() => {
    if (data?.printerSetups.tag[0] && !printerSetup) {
      setPrinterSetup(data.printerSetups.tag[0]);
    }
  }, [data]);

  const printTemplate = ({ type }) => {
    printAlignmentTemplate({
      variables: { type, printerSetup, quantity: parseInt(quantity) }
    });
  };

  return (
    <Form isMobile={isMobile} style={{ borderBottomWidth: 1 }}>
      <Subtitle>Print Alignment Templates</Subtitle>
      <Field>
        <Label>Printer:</Label>
        <Picker
          selectedValue={printerSetup}
          onValueChange={setPrinterSetup}
        >
          {data?.printerSetups.tag.map(option => (
            <Picker.Item key={option} value={option} label={option} />
          ))}
        </Picker>
      </Field>

      <Field>
        <Label>Quantity:</Label>
        <StyledTextInput
          value={quantity}
          onChangeText={setQuantity}
          style={{ width: 60 }}
        />
      </Field>

      <Button
        label="Print Car Template"
        processing={'printing' === formStatus}
        onPress={() => printTemplate({ type: 'car' })}
        disabled={!parseInt(quantity)}
      />

      <Button
        label="Print Motorcycle Template"
        processing={'printing' === formStatus}
        onPress={() => printTemplate({ type: 'motorcycle' })}
        disabled={!parseInt(quantity)}
        style={{ width: 300 }}
      />
    </Form>
  );
};

export default PrintTemplate;
